import React, { useEffect, useReducer, useState } from "react";

import ProgramPerformanceHeader from "./Header";
import ProgramPerformanceTableHeader from "./TableHeader";
import ProgramPerformanceTableRow from "./TableRow";
import TableWrapper from "../shared/bootstrap/TableWrapper";

import { alphabeticalSort } from "../../util/sort";
import { ratingSort } from "../../util/programPerformance";

import { getAllContractHolderPerformances } from "../../api/programPerformance";

import "../../styles/programPerformance.less";
import { GENERIC_ERROR_STRING } from "../../constants";

/**
 * Reducer function for Program Performance Table
 * @param {Object} state
 * @param {Object} action
 * @returns {{sortCol: number, data: ContractHolderPerformanceRating[], sortDir: "asc" | "desc"}}
 */
function sortReducer(state, action) {
  switch (action.type) {
    case "init": {
      return {
        data: action.data.sort((a, b) => alphabeticalSort(a, b, "contractHolder", "asc")), sortDir: "asc", sortCol: 0,
      };
    }

    case "sort": {
      const sortDir = action.sortCol === state.sortCol ? (state.sortDir === "asc" ? "desc" : "asc") : "asc";
      if (action.sortCol === 0) {
        return {
          sortDir,
          sortCol: action.sortCol,
          data: state.data.sort((a, b) => alphabeticalSort(a, b, "contractHolder", sortDir)),
        };
      } else if (action.sortCol === 1) {
        return {
          sortDir, sortCol: action.sortCol, data: state.data.sort(ratingSort("reports", sortDir)),
        };
      } else if (action.sortCol === 2) {
        return {
          sortDir, sortCol: action.sortCol, data: state.data.sort(ratingSort("customerSatisfaction", sortDir)),
        };
      } else if (action.sortCol === 3) {
        return {
          sortDir, sortCol: action.sortCol, data: state.data.sort(ratingSort("informationDistribution", sortDir)),
        };
      } else if (action.sortCol === 4) {
        return {
          sortDir, sortCol: action.sortCol, data: state.data.sort(ratingSort("constractAdherence", sortDir)),
        };
      } else if (action.sortCol === 5) {
        return {
          sortDir, sortCol: action.sortCol, data: state.data.sort(ratingSort("delivery", sortDir)),
        };
      }
    }
  }
}

/**
 * Top-level Contract Holder Program Performance Page Component
 * @returns {Element}
 * @constructor
 */
export default function ProgramPerformance() {
  const [contractHolderPerformances, contractHolderPerformancesDispatch] = useReducer(sortReducer, {
    /** @type {ContractHolderPerformanceRating[]} */ data: [], sortDir: "asc", sortCol: 0,
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = "NASA SEWP V Contract Holder Program Performance";
  }, []);

  useEffect(() => {
    getAllContractHolderPerformances().then(({ data }) => {
      contractHolderPerformancesDispatch({ type: "init", data });
    }).catch(error => {
      setError(GENERIC_ERROR_STRING);
    });
  }, []);

  return (<div id="program-performance-wrapper" className="container-fluid">
    <ProgramPerformanceHeader/>
    {error ? <div>{error}</div> : <TableWrapper id="performance-table">
      <ProgramPerformanceTableHeader sortDir={contractHolderPerformances.sortDir}
                                     sortCol={contractHolderPerformances.sortCol}
                                     contractHolderPerformancesDispatch={contractHolderPerformancesDispatch}/>
      <tbody>
      {contractHolderPerformances.data.map(
        chPerformance => <ProgramPerformanceTableRow key={chPerformance.contractHolder}
                                                     chPerformance={chPerformance}/>)}
      </tbody>
    </TableWrapper>}
  </div>);
}